import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
    data: { animate: false }
  },

  // Featured Modules without children (Onepager only!)
  { path: 'login', loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule) },
  { path: 'redirect', loadChildren: () => import('./modules/redirect/redirect.module').then(m => m.RedirectModule) },
  { path: 'contact', loadChildren: () => import('./modules/contact/contact.module').then(m => m.ContactModule) },

  { path: 'forgot-password', loadChildren: () => import('./modules/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule) },
  { path: 'home', loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule) },
  { path: 'information', loadChildren: () => import('./modules/information/information.module').then(m => m.InformationModule) },
  { path: 'agb', loadChildren: () => import('./modules/agb/agb.module').then(m => m.AgbModule) },
  { path: 'impressum', loadChildren: () => import('./modules/impressum/impressum.module').then(m => m.ImpressumModule) },
  { path: 'datenschutz', loadChildren: () => import('./modules/datenschutz/datenschutz.module').then(m => m.DatenschutzModule) },
  { path: 'nutzung', loadChildren: () => import('./modules/nutzung/nutzung.module').then(m => m.NutzungModule) },
  { path: 'dashboard', loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule) },
  { path: 'components-overview', loadChildren: () => import('./modules/components-overview/components-overview.module').then(m => m.ComponentsOverviewModule) },

  // Featured Modules with children
  { path: 'company', loadChildren: () => import('./modules/company/company.module').then(m => m.CompanyModule) },
  { path: 'user', loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule) },
  { path: 'user-role', loadChildren: () => import('./modules/user-role/user-role.module').then(m => m.UserRoleModule) },
  { path: 'user-profile', loadChildren: () => import('./modules/user-profile/user-profile.module').then(m => m.UserProfileModule) },
  { path: 'right', loadChildren: () => import('./modules/right/right.module').then(m => m.RightModule) },
  { path: 'qrcodes', loadChildren: () => import('./modules/qrcodes/qrcodes.module').then(m => m.QrcodesModule) },
  { path: 'open-house', loadChildren: () => import('./modules/open-house/open-house.module').then(m => m.OpenHouseModule) },
  { path: 'ilockit', loadChildren: () => import('./modules/ilockit/ilockit.module').then(m => m.ILockItModule) },
  { path: 'vecos', loadChildren: () => import('./modules/vecos/vecos.module').then(m => m.VecosModule) },


  // Redirect all routes without match to...
  {
		path: '**',
    redirectTo: 'home',
    data: { animate: false }
	},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { useHash: true })
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
